// broadcast events originating keyboard chords
import { KeyboardEvent } from "data/interface/keyboard"
import keyboard from "keyboardjs"
import { Subject } from "rxjs"

// private module logic //

const keyStream = new Subject<KeyboardEvent>()

function keyEvent(event: KeyboardEvent): void {
  keyStream.next(event)
}

// generic key events
export const TAB = 'TAB'
export const ENTER = 'ENTER'
export const ESC = 'ESC'
export const RIGHT = 'RIGHT'
export const LEFT = 'LEFT'
export const UP = 'UP'
export const DOWN = 'DOWN'
export const SPACE = 'SPACE'
export const SHIFT_TAB = 'SHIFT_TAB'
export const SHIFT_ALT_Z = 'SHIFT_ALT_Z'
export const SHIFT_ALT_R = 'SHIFT_ALT_R'
export const CTRL_Y = 'CTRL_Y'
export const CTRL_ALT = 'CTRL_ALT'
export const CTRL_ALT_A = 'CTRL_ALT_A'
export const CTRL_ALT_B = 'CTRL_ALT_B'
export const CTRL_ALT_D = 'CTRL_ALT_D'
export const CTRL_ALT_F = 'CTRL_ALT_F'
export const CTRL_ALT_I = 'CTRL_ALT_I'
export const CTRL_ALT_P = 'CTRL_ALT_P'
export const CTRL_ALT_R = 'CTRL_ALT_R'
export const CTRL_ALT_L = 'CTRL_ALT_L'
export const CTRL_ALT_M = 'CTRL_ALT_M'
export const CTRL_ALT_N = 'CTRL_ALT_N'
export const CTRL_ALT_T = 'CTRL_ALT_T'
export const CTRL_ALT_C = 'CTRL_ALT_C'
export const CTRL_ALT_V = 'CTRL_ALT_V'
export const CTRL_ALT_O = 'CTRL_ALT_O'
export const CTRL_ALT_H = 'CTRL_ALT_H'
export const CTRL_ALT_S = 'CTRL_ALT_S'
export const CTRL_ALT_U = 'CTRL_ALT_U'
export const CTRL_ALT_E = 'CTRL_ALT_E'
export const CTRL_ALT_W = 'CTRL_ALT_W'
export const CTRL_ALT_X = 'CTRL_ALT_X'
export const CTRL_ALT_1 = 'CTRL_ALT_1'
export const CTRL_ALT_2 = 'CTRL_ALT_2'
export const CTRL_ALT_3 = 'CTRL_ALT_3'
export const CTRL_ALT_4 = 'CTRL_ALT_4'
export const CTRL_ALT_5 = 'CTRL_ALT_5'
export const CTRL_ALT_6 = 'CTRL_ALT_6'
export const CTRL_ALT_7 = 'CTRL_ALT_7'
export const CTRL_ALT_8 = 'CTRL_ALT_8'
export const CTRL_ALT_9 = 'CTRL_ALT_9'
export const CTRL_SHIFT_R = 'CTRL_SHIFT_R'
export const CTRL_SHIFT_BACK = 'CTRL_SHIFT_BACK'
export const CTRL_SHIFT_PLUS = 'CTRL_SHIFT_PLUS'
export const CTRL_SHIFT_MINUS = 'CTRL_SHIFT_UNDERSCORE'
export const CTRL_SHIFT_UNDERSCORE = 'CTRL_SHIFT_UNDERSCORE'
export const CTRL_SHIFT_LEFT = 'CTRL_SHIFT_LEFT'
export const CTRL_SHIFT_RIGHT = 'CTRL_SHIFT_RIGHT'
export const CTRL_SHIFT_UP = 'CTRL_SHIFT_UP'
export const CTRL_SHIFT_DOWN = 'CTRL_SHIFT_DOWN'
export const CTRL_SHIFT_X = 'CTRL_SHIFT_X'
export const TAB_1 = 'TAB_1'
export const TAB_2 = 'TAB_2'
export const TAB_3 = 'TAB_3'
export const TAB_4 = 'TAB_4'
export const TAB_5 = 'TAB_5'
export const TAB_6 = 'TAB_6'
export const TAB_7 = 'TAB_7'
export const TAB_8 = 'TAB_8'
export const TAB_9 = 'TAB_9'

keyboard.bind('tab', () => keyEvent({chord: TAB, down: true}), () => keyEvent({chord: TAB, down: false}))
keyboard.bind('enter', () => keyEvent({chord: ENTER, down: true}), () => keyEvent({chord: ENTER, down: false}))
keyboard.bind('esc', () => keyEvent({chord: ESC, down: true}), () => keyEvent({chord: ESC, down: false}))
keyboard.bind('left', () => keyEvent({chord: LEFT, down: true}), () => keyEvent({chord: LEFT, down: false}))
keyboard.bind('right', () => keyEvent({chord: RIGHT, down: true}), () => keyEvent({chord: RIGHT, down: false}))
keyboard.bind('up', () => keyEvent({chord: UP, down: true}), () => keyEvent({chord: UP, down: false}))
keyboard.bind('down', () => keyEvent({chord: DOWN, down: true}), () => keyEvent({chord: DOWN, down: false}))
keyboard.bind('space', () => keyEvent({chord: SPACE, down: true}), () => keyEvent({chord: SPACE, down: false}))

keyboard.bind('shift + tab', () => keyEvent({chord: SHIFT_TAB, down: true}), () => keyEvent({chord: SHIFT_TAB, down: false}))
keyboard.bind('shift + alt + z', () => keyEvent({chord: SHIFT_ALT_Z, down: true}), () => keyEvent({chord: SHIFT_ALT_Z, down: false}))
keyboard.bind('shift + alt + r', () => keyEvent({chord: SHIFT_ALT_R, down: true}), () => keyEvent({chord: SHIFT_ALT_R, down: false}))
keyboard.bind('ctrl + y', () => keyEvent({chord: CTRL_Y, down: true}), () => keyEvent({chord: CTRL_Y, down: false}))

keyboard.bind('ctrl + alt', () => keyEvent({chord: CTRL_ALT, down: true}), () => keyEvent({chord: CTRL_ALT, down: false}))
keyboard.bind('ctrl + alt + a', () => keyEvent({chord: CTRL_ALT_A, down: true}), () => keyEvent({chord: CTRL_ALT_A, down: false}))
keyboard.bind('ctrl + alt + b', () => keyEvent({chord: CTRL_ALT_B, down: true}), () => keyEvent({chord: CTRL_ALT_B, down: false}))
keyboard.bind('ctrl + alt + c', () => keyEvent({chord: CTRL_ALT_C, down: true}), () => keyEvent({chord: CTRL_ALT_C, down: false}))
keyboard.bind('ctrl + alt + d', () => keyEvent({chord: CTRL_ALT_D, down: true}), () => keyEvent({chord: CTRL_ALT_D, down: false}))
keyboard.bind('ctrl + alt + f', () => keyEvent({chord: CTRL_ALT_F, down: true}), () => keyEvent({chord: CTRL_ALT_F, down: false}))
keyboard.bind('ctrl + alt + i', () => keyEvent({chord: CTRL_ALT_I, down: true}), () => keyEvent({chord: CTRL_ALT_I, down: false}))
keyboard.bind('ctrl + alt + p', () => keyEvent({chord: CTRL_ALT_P, down: true}), () => keyEvent({chord: CTRL_ALT_P, down: false}))
keyboard.bind('ctrl + alt + r', () => keyEvent({chord: CTRL_ALT_R, down: true}), () => keyEvent({chord: CTRL_ALT_R, down: false}))
keyboard.bind('ctrl + alt + l', () => keyEvent({chord: CTRL_ALT_L, down: true}), () => keyEvent({chord: CTRL_ALT_L, down: false}))
keyboard.bind('ctrl + alt + m', () => keyEvent({chord: CTRL_ALT_M, down: true}), () => keyEvent({chord: CTRL_ALT_M, down: false}))
keyboard.bind('ctrl + alt + n', () => keyEvent({chord: CTRL_ALT_N, down: true}), () => keyEvent({chord: CTRL_ALT_N, down: false}))
keyboard.bind('ctrl + alt + t', () => keyEvent({chord: CTRL_ALT_T, down: true}), () => keyEvent({chord: CTRL_ALT_T, down: false}))
keyboard.bind('ctrl + alt + v', () => keyEvent({chord: CTRL_ALT_V, down: true}), () => keyEvent({chord: CTRL_ALT_V, down: false}))
keyboard.bind('ctrl + alt + o', () => keyEvent({chord: CTRL_ALT_O, down: true}), () => keyEvent({chord: CTRL_ALT_O, down: false}))
keyboard.bind('ctrl + alt + h', () => keyEvent({chord: CTRL_ALT_H, down: true}), () => keyEvent({chord: CTRL_ALT_H, down: false}))
keyboard.bind('ctrl + alt + s', () => keyEvent({chord: CTRL_ALT_S, down: true}), () => keyEvent({chord: CTRL_ALT_S, down: false}))
keyboard.bind('ctrl + alt + u', () => keyEvent({chord: CTRL_ALT_U, down: true}), () => keyEvent({chord: CTRL_ALT_U, down: false}))
keyboard.bind('ctrl + alt + e', () => keyEvent({chord: CTRL_ALT_E, down: true}), () => keyEvent({chord: CTRL_ALT_E, down: false}))
keyboard.bind('ctrl + alt + w', () => keyEvent({chord: CTRL_ALT_W, down: true}), () => keyEvent({chord: CTRL_ALT_W, down: false}))
keyboard.bind('ctrl + alt + x', () => keyEvent({chord: CTRL_ALT_X, down: true}), () => keyEvent({chord: CTRL_ALT_X, down: false}))

keyboard.bind('ctrl + alt + one', () => keyEvent({chord: CTRL_ALT_1, down: true}), () => keyEvent({chord: CTRL_ALT_1, down: false}))
keyboard.bind('ctrl + alt + two', () => keyEvent({chord: CTRL_ALT_2, down: true}), () => keyEvent({chord: CTRL_ALT_2, down: false}))
keyboard.bind('ctrl + alt + three', () => keyEvent({chord: CTRL_ALT_3, down: true}), () => keyEvent({chord: CTRL_ALT_3, down: false}))
keyboard.bind('ctrl + alt + four', () => keyEvent({chord: CTRL_ALT_4, down: true}), () => keyEvent({chord: CTRL_ALT_4, down: false}))
keyboard.bind('ctrl + alt + five', () => keyEvent({chord: CTRL_ALT_5, down: true}), () => keyEvent({chord: CTRL_ALT_5, down: false}))
keyboard.bind('ctrl + alt + six', () => keyEvent({chord: CTRL_ALT_6, down: true}), () => keyEvent({chord: CTRL_ALT_6, down: false}))
keyboard.bind('ctrl + alt + seven', () => keyEvent({chord: CTRL_ALT_7, down: true}), () => keyEvent({chord: CTRL_ALT_7, down: false}))
keyboard.bind('ctrl + alt + eight', () => keyEvent({chord: CTRL_ALT_8, down: true}), () => keyEvent({chord: CTRL_ALT_8, down: false}))
keyboard.bind('ctrl + alt + nine', () => keyEvent({chord: CTRL_ALT_9, down: true}), () => keyEvent({chord: CTRL_ALT_9, down: false}))
keyboard.bind('ctrl + alt + num1', () => keyEvent({chord: CTRL_ALT_1, down: true}), () => keyEvent({chord: CTRL_ALT_1, down: false}))
keyboard.bind('ctrl + alt + num2', () => keyEvent({chord: CTRL_ALT_2, down: true}), () => keyEvent({chord: CTRL_ALT_2, down: false}))
keyboard.bind('ctrl + alt + num3', () => keyEvent({chord: CTRL_ALT_3, down: true}), () => keyEvent({chord: CTRL_ALT_3, down: false}))
keyboard.bind('ctrl + alt + num4', () => keyEvent({chord: CTRL_ALT_4, down: true}), () => keyEvent({chord: CTRL_ALT_4, down: false}))
keyboard.bind('ctrl + alt + num5', () => keyEvent({chord: CTRL_ALT_5, down: true}), () => keyEvent({chord: CTRL_ALT_5, down: false}))
keyboard.bind('ctrl + alt + num6', () => keyEvent({chord: CTRL_ALT_6, down: true}), () => keyEvent({chord: CTRL_ALT_6, down: false}))
keyboard.bind('ctrl + alt + num7', () => keyEvent({chord: CTRL_ALT_7, down: true}), () => keyEvent({chord: CTRL_ALT_7, down: false}))
keyboard.bind('ctrl + alt + num8', () => keyEvent({chord: CTRL_ALT_8, down: true}), () => keyEvent({chord: CTRL_ALT_8, down: false}))
keyboard.bind('ctrl + alt + num9', () => keyEvent({chord: CTRL_ALT_9, down: true}), () => keyEvent({chord: CTRL_ALT_9, down: false}))

keyboard.bind('ctrl + shift + r', () => keyEvent({chord: CTRL_SHIFT_R, down: true}), () => keyEvent({chord: CTRL_SHIFT_R, down: false}))
keyboard.bind('ctrl + shift + backspace', () => keyEvent({chord: CTRL_SHIFT_BACK, down: true}), () => keyEvent({chord: CTRL_SHIFT_BACK, down: false}))
keyboard.bind('ctrl + shift + plus', () => keyEvent({chord: CTRL_SHIFT_PLUS, down: true}), () => keyEvent({chord: CTRL_SHIFT_PLUS, down: false}))
keyboard.bind('ctrl + shift + underscore', () => keyEvent({chord: CTRL_SHIFT_UNDERSCORE, down: true}), () => keyEvent({chord: CTRL_SHIFT_UNDERSCORE, down: false}))
keyboard.bind('ctrl + shift + numadd', () => keyEvent({chord: CTRL_SHIFT_PLUS, down: true}), () => keyEvent({chord: CTRL_SHIFT_PLUS, down: false}))
keyboard.bind('ctrl + shift + num-', () => keyEvent({chord: CTRL_SHIFT_UNDERSCORE, down: true}), () => keyEvent({chord: CTRL_SHIFT_UNDERSCORE, down: false}))
keyboard.bind('ctrl + shift + left', () => keyEvent({chord: CTRL_SHIFT_LEFT, down: true}), () => keyEvent({chord: CTRL_SHIFT_LEFT, down: false}))
keyboard.bind('ctrl + shift + right', () => keyEvent({chord: CTRL_SHIFT_RIGHT, down: true}), () => keyEvent({chord: CTRL_SHIFT_RIGHT, down: false}))
keyboard.bind('ctrl + shift + up', () => keyEvent({chord: CTRL_SHIFT_UP, down: true}), () => keyEvent({chord: CTRL_SHIFT_UP, down: false}))
keyboard.bind('ctrl + shift + down', () => keyEvent({chord: CTRL_SHIFT_DOWN, down: true}), () => keyEvent({chord: CTRL_SHIFT_DOWN, down: false}))
keyboard.bind('ctrl + shift + x', () => keyEvent({chord: CTRL_SHIFT_X, down: true}), () => keyEvent({chord: CTRL_SHIFT_X, down: false}))


keyboard.bind('tab + one', () => keyEvent({chord: TAB_1, down: true}), () => keyEvent({chord: TAB_1, down: false}))
keyboard.bind('tab + two', () => keyEvent({chord: TAB_2, down: true}), () => keyEvent({chord: TAB_2, down: false}))
keyboard.bind('tab + three', () => keyEvent({chord: TAB_3, down: true}), () => keyEvent({chord: TAB_3, down: false}))
keyboard.bind('tab + four', () => keyEvent({chord: TAB_4, down: true}), () => keyEvent({chord: TAB_4, down: false}))
keyboard.bind('tab + five', () => keyEvent({chord: TAB_5, down: true}), () => keyEvent({chord: TAB_5, down: false}))
keyboard.bind('tab + six', () => keyEvent({chord: TAB_6, down: true}), () => keyEvent({chord: TAB_6, down: false}))
keyboard.bind('tab + seven', () => keyEvent({chord: TAB_7, down: true}), () => keyEvent({chord: TAB_7, down: false}))
keyboard.bind('tab + eight', () => keyEvent({chord: TAB_8, down: true}), () => keyEvent({chord: TAB_8, down: false}))
keyboard.bind('tab + nine', () => keyEvent({chord: TAB_9, down: true}), () => keyEvent({chord: TAB_9, down: false}))
keyboard.bind('tab + num1', () => keyEvent({chord: TAB_1, down: true}), () => keyEvent({chord: TAB_1, down: false}))
keyboard.bind('tab + num2', () => keyEvent({chord: TAB_2, down: true}), () => keyEvent({chord: TAB_2, down: false}))
keyboard.bind('tab + num3', () => keyEvent({chord: TAB_3, down: true}), () => keyEvent({chord: TAB_3, down: false}))
keyboard.bind('tab + num4', () => keyEvent({chord: TAB_4, down: true}), () => keyEvent({chord: TAB_4, down: false}))
keyboard.bind('tab + num5', () => keyEvent({chord: TAB_5, down: true}), () => keyEvent({chord: TAB_5, down: false}))
keyboard.bind('tab + num6', () => keyEvent({chord: TAB_6, down: true}), () => keyEvent({chord: TAB_6, down: false}))
keyboard.bind('tab + num7', () => keyEvent({chord: TAB_7, down: true}), () => keyEvent({chord: TAB_7, down: false}))
keyboard.bind('tab + num8', () => keyEvent({chord: TAB_8, down: true}), () => keyEvent({chord: TAB_8, down: false}))
keyboard.bind('tab + num9', () => keyEvent({chord: TAB_9, down: true}), () => keyEvent({chord: TAB_9, down: false}))

// public module interface //

const keyService = {
  stream: () => keyStream.asObservable(),
  newEvent: (event: KeyboardEvent) => keyEvent(event)
}

export default keyService
